import {preloadStripeWalletCheckout} from './stripeWalletCheckout.js';

export function detectWatermarkTrialWallet(publishableKey, currency, amount) {
    return new Promise(resolve => {
        let finished = false;
        let host;
        let element;
        const finish = result => {
            if (finished) return;
            finished = true;
            clearTimeout(timer);
            element?.destroy();
            host?.remove();
            resolve(result);
        };
        const fail = (stage, error) => {
            if (finished) return;
            // Provider errors can contain payment details; keep only diagnostic identifiers.
            const identifier = value => typeof value === 'string' && /^[a-zA-Z0-9_]+$/.test(value) ? value : 'unknown';
            console.warn(`Watermark wallet detection failed: stage=${stage}, type=${identifier(error?.type || error?.name)}, code=${identifier(error?.code)}`);
            finish('error');
        };
        const timer = setTimeout(() => finish('timeout'), 3000);
        const initialize = async () => {
            if (!/^pk_(live|test)_/.test(publishableKey) || !/^[a-z]{3}$/.test(currency) ||
                !Number.isSafeInteger(amount) || amount <= 0) throw new Error('Invalid wallet detection configuration');
            await preloadStripeWalletCheckout();
            if (finished) return;
            const elements = window.Stripe(publishableKey).elements({
                mode: 'payment', currency, amount, allowedPaymentMethodTypes: ['card'],
            });
            host = document.createElement('div');
            // A mounted iframe is required for detection; it must never become an interactive checkout.
            host.style.cssText = 'position:fixed;left:-10000px;top:0;width:300px;height:50px;opacity:0;pointer-events:none';
            host.setAttribute('aria-hidden', 'true');
            host.setAttribute('inert', '');
            document.body.appendChild(host);
            element = elements.create('expressCheckout', {
                paymentMethods: {applePay: 'auto', googlePay: 'auto', link: 'never', paypal: 'never', amazonPay: 'never', klarna: 'never'},
            });
            element.on('availablepaymentmethodschange', ({paymentMethods}) => {
                const apple = paymentMethods?.applePay?.available === true;
                const google = paymentMethods?.googlePay?.available === true;
                finish(apple && google ? 'both' : apple ? 'apple_pay' : google ? 'google_pay' : 'unavailable');
            });
            element.on('loaderror', event => fail('load', event.error));
            element.mount(host);
        };
        void initialize().catch(error => fail('initialization', error));
    });
}
